import { CustomFlowId, Question } from '@ch/common/types/data';
import { fieldGroups } from './types';
import { fieldGroupsData } from './const';

export const newFormatData = ({
  questions = [],
  personaQuestion,
}: {
  questions: Question[];
  personaQuestion: Question;
  lang: string;
}) => {
  return [personaQuestion, ...questions].reduce(
    (result, { options, ...question }) => {
      const { identifier } = question;
      const questionResult = {
        ...question,
        options,
      };
      const currentStep = identifier === CustomFlowId.PERSON_TYPE ? fieldGroups.TYPE : fieldGroups.FORM;
      return {
        ...result,
        [currentStep]: {
          ...result[currentStep],
          questions: [...result[currentStep].questions, questionResult],
        },
      };
    },
    {
      ...fieldGroupsData,
    },
  );
};
